import React, { FC } from 'react'
import { OTPInputProps } from 'react-otp-input'

import * as SC from './styled'

export type FormOTPProps = Omit<OTPInputProps, 'onChange' | 'renderInput'> & {
  className?: string
  name: string
  value?: string
  required?: boolean
  disabled?: boolean
  error?: string
  showError?: boolean
  help?: string
  onChange?: (event: { target: { name: string; value: string } }) => void
}

const FormOTP: FC<FormOTPProps> = (props) => {
  const { className, error, showError = true, help, onChange, ...inputProps } = props

  return (
    <SC.Container className={className} $isDisabled={inputProps.disabled}>
      <SC.Otp
        {...inputProps}
        $isError={!!error}
        $isDisabled={inputProps.disabled}
        containerStyle={{
          display: 'flex',
          gap: '15px',
        }}
        inputStyle={{
          width: '22px',
          height: '22px',
          border: 'none',
          borderBottom: '1px solid black',
        }}
        onPaste={(event) => {
          const pastedText = event.clipboardData.getData('Text')

          const digitsOnly = pastedText
            .split(/\t+/)
            .map((str) => str.trim())
            .filter((str) => str !== '')
            .join('')

          // Check: contains only digits?
          if (/^\d+$/.test(digitsOnly)) {
            console.log(digitsOnly) // Safe to use: "85823"

            onChange?.({
              target: {
                name: inputProps.name,
                value: digitsOnly,
              },
            })
          } else {
            console.warn('Invalid paste: non-numeric content blocked')
            // Optionally, show an error message to the user
          }
        }}
        onChange={(v: string) => {
          onChange?.({
            target: {
              name: inputProps.name,
              value: v,
            },
          })
        }}
        renderInput={(props) => <SC.Input {...props} />}
      />
      {help && <SC.Help>{help}</SC.Help>}
      {error && showError && <SC.Error>{error}</SC.Error>}
    </SC.Container>
  )
}

export default FormOTP
